import { useContext, useState } from 'react';

import { members } from '@features/shared/api/fixtures';

import { AuthContext } from '../providers/AuthProvider';

export function useAuth() {
  const ctx = useContext(AuthContext);

  if (!ctx) {
    throw new Error(
      'AuthContext not initialized. Please, wrap your components in <AuthProvider />',
    );
  }

  return ctx;
}

export function useFakeUser(loggedIn?: boolean) {
  const [user, setUser] = useState<(typeof members)[0] | null>(loggedIn ? members[0]! : null);

  return {
    user,
    onLogin: () => setUser(members[0]!),
    onLogout: () => setUser(null),
  };
}
